import styled from "styled-components";
import { disabledCSS } from "components/common";

// Define consistent hover color
const HOVER_COLOR = "#09779E12";

const Item = styled.div`
  color: #01151D;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 16px;
  white-space: nowrap;
  z-index: 9999;
  font-weight: 400;
  font-family: "Source Sans 3", sans-serif;
  font-size: var(--typography-body-size, 16px);
  letter-spacing: var(--typography-body-letterSpacing, -0.04px);
  font-style: normal;
  transition: background-color 0.2s ease;
  
  &:hover {
    background: ${HOVER_COLOR};
    cursor: pointer;
  }
  
  ${({ isNested }) => (isNested ? "padding-right:50px" : "")}
  ${({ disabled }) => (disabled ? disabledCSS : "")}
`;

const Icon = styled.img`
  height: 20px;
  width: 20px;
  margin-right: 12px;
  filter: invert(60%);
`;

const RightChevron = styled.i`
  border: 1px solid #999;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  position: absolute;
  right: 16px;
`;

export { Item, Icon, RightChevron };
